import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <Section bg="cream" data-id="element-298">
      <div className="max-w-4xl mx-auto text-center" data-id="element-299">
        <div className="mb-12" data-id="element-300">
          <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-301">
            Confianza Absoluta
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-302">
            Garantía Wellaging de 7 Días
          </h2>
          <p className="text-xl text-olive font-serif italic" data-id="element-303">
            Resultados Reales o Te Devolvemos Cada Peso
          </p>
        </div>

        <div className="glass-card rounded-[2.5rem] p-10 md:p-16 text-left relative overflow-hidden" data-id="element-304">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-305" />

          <div className="max-w-2xl mx-auto relative z-10" data-id="element-306">
            <p className="text-lg font-light text-charcoal-light mb-8 leading-relaxed" data-id="element-307">
              Entiendo tu escepticismo. La industria del antiaging te mintió
              durante décadas. Por eso voy a hacer algo diferente. Todo el
              riesgo está de mi lado.
            </p>

            <div className="bg-white/50 border border-gold/10 rounded-2xl p-8 mb-10" data-id="element-308">
              <h3 className="font-serif text-2xl text-charcoal mb-6 text-center" data-id="element-309">
                Cómo funciona:
              </h3>
              <ul className="space-y-4 text-charcoal-light font-light" data-id="element-310">
                <li className="flex items-center gap-4" data-id="element-311">
                  <span className="text-gold font-serif italic text-xl" data-id="element-312">
                    01.
                  </span>
                  <span data-id="element-313">Descargá el Método Wellaging 360° hoy.</span>
                </li>
                <li className="flex items-center gap-4" data-id="element-314">
                  <span className="text-gold font-serif italic text-xl" data-id="element-315">
                    02.
                  </span>
                  <span data-id="element-316">Implementá el plan durante 7 días.</span>
                </li>
                <li className="flex items-center gap-4" data-id="element-317">
                  <span className="text-gold font-serif italic text-xl" data-id="element-318">
                    03.
                  </span>
                  <span data-id="element-319">Observá cómo cambia tu energía y tu piel.</span>
                </li>
              </ul>
            </div>

            <div className="text-center" data-id="element-320">
              <p className="font-serif text-2xl text-charcoal mb-4" data-id="element-321">
                Si no funciona, te devolvemos tu dinero.
              </p>
              <p className="text-charcoal-light font-light mb-10" data-id="element-322">
                Sin preguntas. Sin letras chicas.
              </p>

              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_of_Florencia.svg/1200px-Stylized_signature_of_Florencia.svg.png" alt="Firma Florencia" className="h-12 mx-auto opacity-40 grayscale" onError={e => e.currentTarget.style.display = 'none'} data-id="element-323" />
              <p className="font-serif italic text-charcoal-light mt-2" data-id="element-324">
                Dra. Florencia Bertotto
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}